// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6a6d28e8503736616f28","655":"bff40745be9b7887548a"}[chunkId] + ".js";
};